import { render, staticRenderFns } from "./ShowVideoPopup.vue?vue&type=template&id=1ed6fc32&scoped=true&"
import script from "./ShowVideoPopup.vue?vue&type=script&lang=ts&"
export * from "./ShowVideoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ShowVideoPopup.vue?vue&type=style&index=0&id=1ed6fc32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed6fc32",
  null
  
)

export default component.exports